import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"


export default class extends Controller {
  static values = { url: String }

  connect() {
    this.sortable = Sortable.create(this.element, {
      onEnd: this.end.bind(this)
    })
  }

  end(event) {
    let id = event.item.dataset.id
    let url = this.urlValue.replace(":id", id)

    let data = new FormData()
    data.append("position", event.newIndex + 1)

    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    fetch(url, {
      method: 'PATCH',
      body: data,
      headers: {
        'X-CSRF-Token': csrfToken
      }
    })
  }
}
